export default {
  title01: "Погода сейчас",
  title02: "24 часа",
  title03: "Показать погоду за 10 дней",
  title04: "ИКВ",
  title05: "Смотерть всю информацию",
  title06: "ВОСХОД И ЗАХОД СОЛНЦА",
  title07: "ФАЗЫ ЛУНЫ",
  title08: "Следующее полнолуние",
  title09: "Следующее новолуние",
  title10: "ДЕНЬ",
  title11: "НОЧЬ",
  title12: "Восход солнца",
  title13: "Заход солнца",
  title14: "Восход луны",
  title15: "Заход луны",
  title16: "Источник",
  title17: "Начать",
  title18: "Закончить",
  title19: "Использовать текущее местоположение",
  title20: "Искать город",
  title21: "Ощущается как",
  title22: "В тени ощущается как",
  title23: "Сейчас",
  title24: "Сегодня",
  title25: "ВС",
  title26: "ПН",
  title27: "ВТ",
  title28: "СР",
  title29: "ЧТ",
  title30: "ПТ",
  title31: "СБ",
  title32: "Загрузка...",
  title33: "Сейчас",
  title34: "Почасовой прогноз",
  title35: "Ежедневный прогноз",
  title36: "Солнце и Луна",
  title37: "Качество воздуха",
  title38: "Для связи: xlf550402@gmail.com",
  title39: "Соглашение о конфиденциальности",
  title40: "Авторские права © comfortweather.com 2020 - 2025. Все права защищены.",
  title41: "Данные предоставлены",
  title42: "Макс.",
  title43: "Мин.",
  title44: "Принять",
  title45:
    "Спасибо, что пользуетесь ComfortWeather! Чтобы лучше защитить ваши законные права и интересы, пожалуйста, внимательно прочитайте ",
  title46: "Политику конфиденциальности",
  title47: " перед использованием. ",
  title48: "",
  title49: "Для связи: xyjph123@gmail.com",
  title50: "Авторские права © 24hweather.com 2020 - 2025. Все права защищены.",
  title51:
    "Спасибо, что пользуетесь 24hweather! Чтобы лучше защитить ваши законные права и интересы, пожалуйста, внимательно прочитайте ",
};
